const buckets = [];

buckets['127.0.0.1'] = 'https://s3.amazonaws.com/alexia-assets-dev/assets/';
buckets['localhost'] = 'https://s3.amazonaws.com/alexia-assets-dev/assets/';
buckets['alexia-dev.constellationagency.com'] = 'https://s3.amazonaws.com/alexia-assets-dev/assets/';
buckets['alexia-stg.constellationagency.com'] = 'https://s3.amazonaws.com/alexia-assets-stg/assets/';
buckets['alexia-hotfix.constellationagency.com'] = 'https://s3.amazonaws.com/alexia-assets-stg/assets/';
buckets['alexia.constellationagency.com'] = 'https://s3.amazonaws.com/alexia-assets-prd/assets/';

export default buckets;



// WEBPACK FOOTER //
// ./src/fileUploader/Buckets.js